import React, { useEffect, useRef } from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";

export const PaperBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();
  const canvasRef = useRef<HTMLCanvasElement>(null);

  // Deterministic dust/film speckle positions
  const dustParticles = [
    { x: 0.15, y: 0.25, size: 2.5, opacity: 0.15 },
    { x: 0.85, y: 0.15, size: 3.0, opacity: 0.1 },
    { x: 0.35, y: 0.65, size: 2.0, opacity: 0.2 },
    { x: 0.65, y: 0.85, size: 1.8, opacity: 0.18 },
    { x: 0.5, y: 0.45, size: 3.5, opacity: 0.08 },
  ];

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // Elegant warm beige paper base color
    ctx.fillStyle = "#faf6ed";
    ctx.fillRect(0, 0, width, height);

    // Dynamic warm paper vignette gradient
    const vignette = ctx.createRadialGradient(
      width / 2,
      height / 2,
      width / 4,
      width / 2,
      height / 2,
      height * 0.75,
    );
    vignette.addColorStop(0, "rgba(255, 255, 255, 0)");
    vignette.addColorStop(1, "rgba(216, 203, 180, 0.15)"); // warm shadow at borders
    ctx.fillStyle = vignette;
    ctx.fillRect(0, 0, width, height);

    // Draw textured dust grains
    ctx.fillStyle = "rgba(40, 30, 20, 0.12)";
    dustParticles.forEach((dust, idx) => {
      // Slow drifting motion using deterministic waves
      const moveX = Math.sin(frame * 0.003 + idx * 50) * 80;
      const moveY = Math.cos(frame * 0.002 + idx * 80) * 80;
      const currentX = (dust.x * width + moveX + width) % width;
      const currentY = (dust.y * height + moveY + height) % height;

      ctx.beginPath();
      ctx.arc(currentX, currentY, dust.size, 0, Math.PI * 2);
      ctx.fill();
    });

    // Draw some subtle paper line fibers
    ctx.strokeStyle = "rgba(100, 80, 60, 0.012)";
    ctx.lineWidth = 1;
    for (let i = 0; i < 4; i++) {
      const startX = Math.abs(Math.sin(i * 123)) * width;
      const startY = Math.abs(Math.cos(i * 321)) * height;
      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.quadraticCurveTo(
        startX + 50,
        startY + 100,
        startX + 120,
        startY + 80,
      );
      ctx.stroke();
    }
  }, [frame, width, height]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1,
      }}
    />
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
